<template>
  <v-dialog v-model="open" max-width="480">
    <v-card rounded="lg">
      <v-card-title class="text-h6">
        Settings
      </v-card-title>
      <v-card-text>
        <v-checkbox
          v-model="gzipRequests"
          label="GZip Requests"
          hint="Compress large schedule commits before sending them. Only enable this on servers where the RDrive API has request decompression deployed — otherwise commits fail with a validation error."
          persistent-hint
          density="comfortable"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" variant="text" @click="open = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue';
import { usePreferencesStore } from '@/stores/preferences';

const open = defineModel({ type: Boolean, default: false });

const preferencesStore = usePreferencesStore();

const gzipRequests = computed({
  get: () => preferencesStore.gzipRequests,
  set: (value) => preferencesStore.setGzipRequests(value),
});
</script>
